import React from 'react';
import {observer} from 'mobx-react';
import {calendarDate} from 'shared/tools';
import EditBasicInfoModal from './EditBasicInfoModal';
import {t} from 'shared/core';
import InfoPanel from './InfoPanel';
import _ from 'lodash';

const ATTRIBUTES = [
  {
    label: 'employees.profile.personal.First Name',
    render: ({employee}) => employee.firstName,
  },
  {
    label: 'employees.profile.personal.Preferred Name',
    render: ({employee}) => employee.preferredName,
  },
  {
    label: 'employees.profile.personal.Middle Name',
    render: ({employee}) => employee.middleName,
  },
  {
    label: 'employees.profile.personal.Last Name',
    render: ({employee}) => employee.lastName,
  },
  {
    label: 'employees.profile.personal.Preferred Last Name',
    render: ({employee}) => employee.preferredLastName,
  },
  {
    label: 'employees.profile.personal.Current Gender Identity',
    render: ({employee}) => t(employee.genderView)
  },
  {
    label: 'employees.profile.personal.Birthdate',
    render: ({employee}) => calendarDate(employee.birthDate)
  },
  {
    label: 'employees.profile.personal.Employee Number',
    render: ({employee}) => employee.employeeNumber
  },
];

const BasicInformation = observer(({uiState}) => {
  const {employee} = uiState;

  return (
    <>
      <InfoPanel
        employee={employee}
        canEdit={uiState.editDataPermission('::PERSONAL_INFORMATION')}
        onEdit={() => uiState.openBasicInfoModal()}
        title={t('employees.profile.personal.Basic Information')}
        attributes={ATTRIBUTES}
      />
      <EditBasicInfoModal uiState={uiState} />
    </>
  );
});

export default BasicInformation;
